import './Home.css';
import Menu from '../Menu/Menu';
import Content from '../Content/Content';
function Home() {
  return (
    <>
    <div className='container my-5 home-container'>
        <Content />
    </div>
    </>
  );
}

export default Home;
